import type { Announcement } from './api'

export const statusChip: Record<Announcement['status'], { label: string; tone: string }> = {
  draft: { label: 'Draft', tone: '' },
  sending: { label: 'Sending', tone: 'warn' },
  sent: { label: 'Sent', tone: 'ok' },
}

/** The chip for a status, falling back to Draft for one the page doesn't know. */
export function chipFor(
  status: string | null | undefined,
  published = false,
  scheduled = false,
): { label: string; tone: string } {
  if (published) return { label: status === 'sending' ? 'Publishing' : 'Published', tone: 'ok' }
  if (scheduled && (status === 'draft' || !status)) return { label: 'Scheduled', tone: 'lime' }
  return status === 'sending' || status === 'sent' ? statusChip[status] : statusChip.draft
}

/** A share as a whole percentage, such as "42%" (0% when there's nothing to divide by). */
export function percent(part: number, whole: number): string {
  return `${whole > 0 ? Math.round((part / whole) * 100) : 0}%`
}
